import { all, takeEvery } from 'redux-saga/effects'

import {
    MANAGE_GROUPS_DIALOG_INIT,
    MANAGE_GROUPS_DIALOG_IMPORT,
    MANAGE_GROUPS_DIALOG_CREATE_NEW_GROUP,
    MANAGE_GROUPS_DIALOG_IMPORT_SINGLE,
    MANAGE_GROUPS_DIALOG_IMPORT_REMOVE,
} from './constants'

import dialogInitCallSaga from './sagas/initSaga'
import dialogCreateNewGroupCallSaga from './sagas/createNewGroupSaga'
import dialogImportCallSaga from './sagas/importMultipleSaga'
import dialogImportSingleCallSaga from './sagas/importSingleSaga'
import dialogRemoveCallSaga from './sagas/removeSaga'

export default function* manageGroupsSaga() {
    yield all([
        takeEvery(MANAGE_GROUPS_DIALOG_INIT, dialogInitCallSaga),
        takeEvery(MANAGE_GROUPS_DIALOG_IMPORT, dialogImportCallSaga),
        takeEvery(MANAGE_GROUPS_DIALOG_CREATE_NEW_GROUP, dialogCreateNewGroupCallSaga),
        takeEvery(MANAGE_GROUPS_DIALOG_IMPORT_SINGLE, dialogImportSingleCallSaga),
        takeEvery(MANAGE_GROUPS_DIALOG_IMPORT_REMOVE, dialogRemoveCallSaga),
    ])
}
